import * as React from "react";
import {PagerModel} from "./PagerModel";

interface Props {
    model?: PagerModel;
    onOffsetUpdate?: (page: number) => void;
}

export class Pager extends React.Component<Props, {}> {


    constructor(props: Props) {
        super(props);
        console.log("PROPS = ", props);
    }

    getPages(): number[] {
        if (this.props.model.nrOfResults == 0 || this.props.model.limit <= 0) {
            return [];
        }
        var pages = [];
        var nrOfPages = this.props.model.nrOfResults / this.props.model.limit;
        for (var i = 0; i < nrOfPages; i++) {
            pages.push(i);
        }
        return pages;
    };


    setOffset(page: number) {
        this.props.onOffsetUpdate(page * this.props.model.limit)
    }

    getPageButtonClass(page): string {
        var css = "paginate_button";
        var offset = this.props.model.offset;
        var limit = this.props.model.limit;

        if (page == (offset / limit)) {
            css += " active";
        }

        return css;
    }

    displayPage(page: number) {
        var offset = this.props.model.offset ? this.props.model.offset : 0;
        var limit = this.props.model.limit;
        var nrOfPages = this.props.model.nrOfResults / this.props.model.limit;

        if (nrOfPages < 20) {
            return true;
        }
        var currentPage = (offset / limit);
        if (page < 4 || page > nrOfPages - 5) {
            return true;
        } else if (page > currentPage - 4 && page < currentPage + 4) {
            return true;
        } else {
            return false;
        }
    }

    getPageButtons() {
        var prev = 0;
        var buttons = [];
        this.getPages().forEach((p, i) => {
            if (!this.displayPage(p)) {
                return false;
            }

            if (i - prev > 1) {
                buttons.push(<li key={"space" + i} className="paginate_button page-space"><a>...</a></li>);
            }
            prev = i;
            buttons.push(
                (
                    <li key={"pager-" + p} onClick={this.setOffset.bind(this, p)}
                        className={this.getPageButtonClass(p)}>
                        <a>
                            {p + 1}
                        </a>
                    </li>
                )
            );
        })
        return buttons;

    }

    previous(e) {
        if (this.props.model.offset - this.props.model.limit >= 0) {
            this.props.onOffsetUpdate(this.props.model.offset - this.props.model.limit);
        }
    }

    next(e) {
        if (this.props.model.offset + this.props.model.limit < this.props.model.nrOfResults) {
            this.props.onOffsetUpdate(this.props.model.offset + this.props.model.limit);
        }
    }

    render() {
        return (
            <div className="dataTables_paginate paging_simple_numbers">
                <ul className="pagination">
                    <li className="paginate_button previous" onClick={this.previous.bind(this)}>
                        <a tabIndex={0}>
                            Prev
                        </a>
                    </li>
                    {this.getPageButtons()}
                    <li className="paginate_button next" onClick={this.next.bind(this)}>
                        <a tabIndex={0}>
                            Next
                        </a>
                    </li>
                </ul>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/app/ui/list/Pager.tsx